module.exports = __webpack_public_path__ + "img/img3.cc80b436.svg";